'use client'

import React, { useEffect, useState } from 'react'
import { NextPage } from 'next'
import { isDev } from 'app/general'
import IsLoading from './isLoading'
import NProgress from 'nprogress' //nprogress module
import 'nprogress/nprogress.css'
import { resetLoading } from 'actions/general'
import { useAppDispatch, useAppSelector } from 'reducers/storeHooks'

//Binding events.
//TODO
//Add router events for next 13
// Router.events.on('routeChangeStart', () => NProgress.start())
// Router.events.on('routeChangeComplete', () => NProgress.done())
// Router.events.on('routeChangeError', () => NProgress.done())

interface Props { }
const IsLoadingManager: NextPage<Props> = (props: Props) => {
  const isLoading = useAppSelector(state => state.mainReducer.isLoading)
  const [showLoading, setShowLoading] = useState(false)
  const [timer, setTimer] = useState<any>(null)

  const dispatch = useAppDispatch()

  useEffect(() => {
    isDev && console.log("IsLoadingManager", {
      isLoading, showLoading, timer
    })
    setShowLoading(isLoading)
    if (isLoading) {
      const t = setTimeout(() => {
        dispatch(resetLoading())
      }, 8000)
      setTimer(t)
    }
    else {
      clearTimeout(timer)
      setTimer(null)
    }

  }, [isLoading])

  if (showLoading) {
    NProgress.start()
    return <IsLoading />
  } else {
    NProgress.done()
    return <></>
  }
}

export default IsLoadingManager
